import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { EntityPagedRequestParameters, EntityOrderedRequestParameters, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BehaviorSubject, Observable, of } from "rxjs";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { CnpjAssociadoAgenteFinanceiroSCR } from "src/app/model/cnpj-associado-agente-financeiro-scr.model";
import Utils from "src/app/shared/fgi-utils";
import { IntegracaoService } from "../../integracao.service";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { MensagemService } from "src/app/features/mensagem.service";


@Component({
    selector: 'app-scr-associados-listagem',
    templateUrl: 'scr-associados-listagem.component.html',
    standalone: false
})
export class ScrAssociadosListagemComponent {

  constructor(private serviceSCR: IntegracaoService,
    private modalService: BnModalMessageService,
    private mensagemService: MensagemService){}
 
  @Input() public agentesFinanceiros:AgenteFinanceiro[];
  @Input() public associados: CnpjAssociadoAgenteFinanceiroSCR[];
  @Input() public podeEnviarScr: boolean;
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public aoExportarAssociados:EventEmitter<any> = new EventEmitter<any>();

  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

 
  retornaSiglaPorIdAgente(id):string{ 
    return this.agentesFinanceiros.filter(e=>e.id==id)[0].sigla;
  }

  bntExportarAssociados(){
    this.aoExportarAssociados.emit(null);
  }

  retornaCnpjPorIdAssociado(id):string{ 
    return this.agentesFinanceiros.filter(e=>e.id==id)[0].cnpj
  }

  nomeAgenteFinanceiroPorId(id:number){
    return Utils.nomeAgentePorId(id, this.agentesFinanceiros);
  }
  //TODO melhorar essas abreviacoes.
  nomeReduzido(nomeCheio:string):string{
    let a = nomeCheio.replace('BANCO','BCO');
    a = a.replace('COOPERATIVA','COOP');
    a = a.replace('CRÉDITO','CRÉD');
    a = a.replace('CREDITO','CRÉD');
    return a.trim();
  }

  nomeAgenteFinanceiroPorCnpj(cnpj:string){
    return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.associados = this.associados.sort((a, b) => {
      if (ord.sentido === 'asc') {
        return this.compara(a, b, ord.atributo);
      } else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
      return 0;
    } else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      } else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    const _index = prop.indexOf('.');
    if (_index > -1) {
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  public excluirAssociado(idAssociado: number){
    this.abreModalConfirmacao('Confirmar exclusão?').then(resp => {
      if(resp === true) {
        this.serviceSCR.excluirScrAssociado(idAssociado).subscribe((t) => {
          console.log(t);
          this.mensagemService.adicionarMensagemSucesso("CNPJ do associado: " + t.cnpjAssociado + " excluído com sucesso!")
          this.associados = this.associados.filter(associado => associado.id != t.id);
        })
      }
    })
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
        const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
        return resultadoConfimacao.value === 'ok';
    } catch (e) {
        return false;
    }
  }

}
